import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/cpcic-admin-release/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 注册、登录、注销
 * */
import util from '@/libs/util';
import router from '@/router';
import Setting from '@/setting';
import { AccountLogin, AccountRegister } from '@api/account';
import { Modal } from 'view-design';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param account {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var dispatch = _ref.dispatch;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$account = _ref2.account,
        account = _ref2$account === void 0 ? '' : _ref2$account,
        _ref2$password = _ref2.password,
        password = _ref2$password === void 0 ? '' : _ref2$password;
      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        AccountLogin({
          account: account,
          password: password
        }).then(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                  // 整个系统依赖这两个数据进行校验和存储
                  // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                  // token 代表用户当前登录状态 建议在网络请求中携带 token
                  // 如有必要 token 需要定时更新，默认保存一天，可在 setting.js 中修改
                  // 如果你的 token 不是通过 cookie 携带，而是普通字段，也可视情况存储在 localStorage
                  util.cookies.set('uuid', res.data.token);
                  util.cookies.set('token', res.data.token);
                  // 设置 vuex 用户信息
                  _context.next = 4;
                  return dispatch('admin/user/set', res.data.account, {
                    root: true
                  });
                case 4:
                  _context.next = 6;
                  return dispatch('load');
                case 6:
                  // 结束
                  resolve();
                case 7:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(function (err) {
          // console.log('err: ', err);
          reject(err);
        });
      });
    },
    /**
     * @description 退出登录
     * */
    logout: function logout(_ref4) {
      var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref5$confirm = _ref5.confirm,
        confirm = _ref5$confirm === void 0 ? false : _ref5$confirm,
        vm = _ref5.vm;
      function logout() {
        return _logout.apply(this, arguments);
      }
      function _logout() {
        _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // 删除cookie
                util.cookies.remove('token');
                util.cookies.remove('uuid');
                // 清空 vuex 用户信息
                _context2.next = 4;
                return dispatch('admin/user/set', {}, {
                  root: true
                });
              case 4:
                // 跳转路由
                router.push({
                  name: 'login'
                });
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        Modal.confirm({
          title: vm.$t('basicLayout.logout.confirmTitle'),
          content: vm.$t('basicLayout.logout.confirmContent'),
          onOk: function onOk() {
            logout();
          }
        });
      } else {
        logout();
      }
    },
    /**
     * @description 注册
     * @param {Object} param context
     * @param {Object} param mail {String} 邮箱
     * @param {Object} param password {String} 密码
     * @param {Object} param mobile {String} 手机号码
     * @param {Object} param captcha {String} 验证码
     */
    register: function register(_ref6) {
      var dispatch = _ref6.dispatch;
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref7$mail = _ref7.mail,
        mail = _ref7$mail === void 0 ? '' : _ref7$mail,
        _ref7$password = _ref7.password,
        password = _ref7$password === void 0 ? '' : _ref7$password,
        _ref7$mobile = _ref7.mobile,
        mobile = _ref7$mobile === void 0 ? '' : _ref7$mobile,
        _ref7$captcha = _ref7.captcha,
        captcha = _ref7$captcha === void 0 ? '' : _ref7$captcha;
      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        // AccountRegister({
        //     mail,
        //     password,
        //     mobile,
        //     captcha
        // })
        //     .then(async res => {
        //         // 注册成功后，完成与登录一致的操作
        //         // 注册也可视情况不返还 uuid、token 等数据，在注册完成后，由前端自动执行一次登录逻辑
        //         util.cookies.set('uuid', res.uuid);
        //         util.cookies.set('token', res.token);
        //         // 设置 vuex 用户信息
        //         await dispatch('admin/user/set', res.info, { root: true });
        //         // 用户登录后从持久化数据加载一系列的设置
        //         await dispatch('load');
        //         // 结束
        //         resolve();
        //     })
        //     .catch(err => {
        //         // console.log('err: ', err);
        //         reject(err);
        //     })
      });
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {Object} loadOpenedTabs 是否加载页签信息
     */
    load: function load(_ref8) {
      var state = _ref8.state,
        dispatch = _ref8.dispatch;
      var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref9$loadOpenedTabs = _ref9.loadOpenedTabs,
        loadOpenedTabs = _ref9$loadOpenedTabs === void 0 ? true : _ref9$loadOpenedTabs;
      return new Promise(/*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch('admin/user/load', null, {
                  root: true
                });
              case 2:
                _context3.next = 4;
                return dispatch('admin/page/openedLoad', {
                  loadOpenedTabs: loadOpenedTabs
                }, {
                  root: true
                });
              case 4:
                // end
                resolve();
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref10.apply(this, arguments);
        };
      }());
    }
  }
};